import _classCallCheck from "/home/runner/work/greenlight/greenlight/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/greenlight/greenlight/node_modules/@babel/runtime/helpers/esm/createClass.js";
var ModalAccessibility = /*#__PURE__*/function () {
  /**
   * Constructor
   *
   * @param {Element} modal
   * @param {Function} closeCallback
   */
  function ModalAccessibility(modal, closeCallback) {
    _classCallCheck(this, ModalAccessibility);
    this.modal = modal;
    this.closeCallback = closeCallback;
    this.focusableElements = [];
    this.focusableElementsQuery = this.defaultFocusableElementsQuery;
    this._isOpen = false;
  }

  /**
   * Set modal
   *
   * @param {Element} modal
   */
  _createClass(ModalAccessibility, [{
    key: "modal",
    get:
    /**
     * Get modal
     *
     * @return {Element}
     */
    function get() {
      return this._modal;
    }

    /**
     * Set isOpen
     *
     * @param {Boolean}
     */,
    set: function set(modal) {
      if (this.modal) {
        this.destroyEvents();
      }
      this._modal = modal;
      this.createEvents();
    }
  }, {
    key: "isOpen",
    get:
    /**
     * Get isOpen
     *
     * @return {Boolean}
     */
    function get() {
      return this._isOpen;
    }

    /**
     * Prior focused element
     *
     * @param {null|Element} element
     */,
    set: function set(isOpen) {
      this._isOpen = isOpen;
    }
  }, {
    key: "priorFocusedElement",
    get:
    /**
     * Get prior focused element
     *
     * @return {null|Element}
     */
    function get() {
      return this._priorFocusedElement;
    }

    /**
     * Set focusable elements
     *
     * @param NodeListOf<Element> elements
     */,
    set: function set(element) {
      this._priorFocusedElement = element;
    }
  }, {
    key: "focusableElements",
    get:
    /**
     * Get focusable elements
     *
     * @return NodeListOf<Element>
     */
    function get() {
      return this._focusableElements;
    }

    /**
     * Open
     *
     * @param {Element|Boolean} element containing focusable elements
     */,
    set: function set(elements) {
      this._focusableElements = elements;
    }
  }, {
    key: "open",
    value: function open() {
      var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.isOpen = true;
      this.focusableElements = this.queryFocusableElements(element ? element : this.modal);
      this.priorFocusedElement = document.activeElement;
      this.focusFirstFocusableElement();
    }

    /**
     * Close
     */
  }, {
    key: "close",
    value: function close() {
      this.isOpen = false;
      this.focusableElements = [];
      this.focusPriorFocusedElement();
      this.priorFocusedElement = null;
    }

    /**
     * Focus first focusable element
     */
  }, {
    key: "focusFirstFocusableElement",
    value: function focusFirstFocusableElement() {
      if (this.firstFocusableElement) {
        this.firstFocusableElement.focus();
      }
    }

    /**
     * Focus last focusable element
     */
  }, {
    key: "focusLastFocusableElement",
    value: function focusLastFocusableElement() {
      if (this.lastFocusableElement) {
        this.lastFocusableElement.focus();
      }
    }

    /**
     * Focus prior focused element
     */
  }, {
    key: "focusPriorFocusedElement",
    value: function focusPriorFocusedElement() {
      if (this.priorFocusedElement) {
        this.priorFocusedElement.focus();
      }
    }

    /**
     * Can capture events
     *
     * @returns {Boolean}
     */
  }, {
    key: "canCaptureEvents",
    value: function canCaptureEvents() {
      return this.isOpen;
    }

    /**
     * Create events
     */
  }, {
    key: "createEvents",
    value: function createEvents() {
      this.keydownEventBind = this.keydownEvent.bind(this);
      this.modal.addEventListener('keydown', this.keydownEventBind);
    }

    /**
     * Destroy events
     */
  }, {
    key: "destroyEvents",
    value: function destroyEvents() {
      this.modal.removeEventListener('keydown', this.keydownEventBind);
    }

    /**
     * Keydown Event
     *
     * @param {event} e
     */
  }, {
    key: "keydownEvent",
    value: function keydownEvent(e) {
      if (this.canCaptureEvents()) {
        if (this.isKeyTab(e.keyCode)) {
          this.keydownTab(e);
        }
        if (this.isKeyEsc(e.keyCode)) {
          this.keydownEsc(e);
        }
      }
    }

    /**
     * Keydown tab
     *
     * @param {Event} e
     */
  }, {
    key: "keydownTab",
    value: function keydownTab(e) {
      if (this.focusableElements.length <= 1) {
        e.preventDefault();
        return;
      }
      if (e.shiftKey) {
        if (document.activeElement === this.firstFocusableElement) {
          e.preventDefault();
          this.focusLastFocusableElement();
        }
      } else {
        if (document.activeElement === this.lastFocusableElement) {
          e.preventDefault();
          this.focusFirstFocusableElement();
        }
      }
    }

    /**
     * Keydown esc
     *
     * @param {Event} e
     */
  }, {
    key: "keydownEsc",
    value: function keydownEsc(e) {
      this.closeCallback();
    }

    /**
     * Is key tab
     *
     * @param code
     * @returns {boolean}
     */
  }, {
    key: "isKeyTab",
    value: function isKeyTab(code) {
      return code === 9;
    }

    /**
     * Is key esc
     *
     * @param code
     * @returns {boolean}
     */
  }, {
    key: "isKeyEsc",
    value: function isKeyEsc(code) {
      return code === 27;
    }

    /**
     * Query focusable elements
     *
     * @param {Element} element
     * @returns {NodeListOf<Element>}
     */
  }, {
    key: "queryFocusableElements",
    value: function queryFocusableElements(element) {
      return element.querySelectorAll(this.focusableElementsQuery.join(','));
    }

    /**
     * Set focusable elements query
     *
     * @param {Array} query
     */
  }, {
    key: "focusableElementsQuery",
    get:
    /**
     * Get focusable elements query
     *
     * @return {Array}
     */
    function get() {
      return this._focusableElementsQuery;
    }

    /**
     * Get default focusable elements query
     *
     * @return {Array}
     */,
    set: function set(query) {
      this._focusableElementsQuery = query;
    }
  }, {
    key: "defaultFocusableElementsQuery",
    get: function get() {
      return ['a[href]:not([tabindex="-1"])', 'area[href]:not([tabindex="-1"])', 'input:not([disabled]):not([tabindex="-1"])', 'select:not([disabled]):not([tabindex="-1"])', 'textarea:not([disabled]):not([tabindex="-1"])', 'button:not([disabled]):not([tabindex="-1"])', '[tabindex="0"]'];
    }

    /**
     * First focusable element
     *
     * @returns {Element|boolean}
     */
  }, {
    key: "firstFocusableElement",
    get: function get() {
      if (this.focusableElements.length) {
        return this.focusableElements[0];
      }
      return false;
    }

    /**
     * Last focusable element
     *
     * @returns {Element|boolean}
     */
  }, {
    key: "lastFocusableElement",
    get: function get() {
      if (this.focusableElements.length) {
        return this.focusableElements[this.focusableElements.length - 1];
      }
      return false;
    }
  }]);
  return ModalAccessibility;
}();
export default ModalAccessibility;